document.documentElement.classList.add('vg-js');

function vgInitReveal() {
  var els = document.querySelectorAll('.vg-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('vg-visible'); });
    return;
  }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('vg-visible');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
  els.forEach(function (el) { obs.observe(el); });
  setTimeout(function () { els.forEach(function (el) { el.classList.add('vg-visible'); }); }, 2500);
}

function vgInitFaq() {
  var items = document.querySelectorAll('.vg-faq__item');
  if (!items.length) return;
  items.forEach(function (item) {
    var btn = item.querySelector('.vg-faq__pregunta');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var abierto = item.classList.contains('vg-faq__item--abierto');
      items.forEach(function (i) { i.classList.remove('vg-faq__item--abierto'); });
      if (!abierto) item.classList.add('vg-faq__item--abierto');
    });
  });
}

function vgInitGaleriaProducto() {
  var root = document.querySelector('[data-vg-galeria]');
  if (!root) return;
  var principal = root.querySelector('[data-vg-galeria-principal]');
  var minis = root.querySelectorAll('[data-vg-mini]');
  if (!principal || !minis.length) return;
  minis.forEach(function (mini) {
    mini.addEventListener('click', function () {
      var full = mini.getAttribute('data-full');
      var alt = mini.getAttribute('data-alt') || '';
      if (!full) return;
      principal.src = full;
      principal.alt = alt;
      minis.forEach(function (m) { m.classList.remove('vg-mini--activa'); });
      mini.classList.add('vg-mini--activa');
    });
  });
}

function vgInitVariantes() {
  var root = document.querySelector('[data-vg-producto]');
  if (!root) return;
  var datosEl = root.querySelector('[data-vg-variantes-json]');
  if (!datosEl) return;
  var variantes;
  try { variantes = JSON.parse(datosEl.textContent); } catch (e) { return; }

  var botones = root.querySelectorAll('[data-vg-opcion]');
  var inputId = root.querySelector('[data-vg-input-id]');
  var precioEls = root.querySelectorAll('[data-vg-precio]');
  var compareEl = root.querySelector('[data-vg-compare]');
  var botonesComprar = root.querySelectorAll('[data-vg-comprar]');
  var botonDos = root.querySelector('[data-vg-dos]');
  if (!botones.length || !inputId) return;

  function formatear(centavos) {
    return (centavos / 100).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }

  function seleccionar(valor, grupo) {
    grupo.querySelectorAll('[data-vg-opcion]').forEach(function (b) { b.classList.remove('vg-opcion--activa'); });
    grupo.querySelector('[data-vg-opcion="' + valor + '"]').classList.add('vg-opcion--activa');
    actualizar();
  }

  function actualizar() {
    var seleccionActiva = {};
    root.querySelectorAll('[data-vg-grupo]').forEach(function (grupo) {
      var activo = grupo.querySelector('.vg-opcion--activa');
      if (activo) seleccionActiva[grupo.getAttribute('data-vg-grupo')] = activo.getAttribute('data-vg-opcion');
    });
    var variante = variantes.find(function (v) {
      return v.opciones.every(function (o) { return seleccionActiva[o.nombre] === o.valor; });
    });
    if (!variante) return;
    inputId.value = variante.id;
    precioEls.forEach(function (el) { el.textContent = formatear(variante.precio); });
    if (compareEl) {
      if (variante.compareAt && variante.compareAt > variante.precio) {
        compareEl.textContent = formatear(variante.compareAt);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }
    botonesComprar.forEach(function (btn) {
      if (variante.disponible) {
        btn.disabled = false;
        btn.textContent = btn.getAttribute('data-texto-disponible') || 'Añadir al carrito';
      } else {
        btn.disabled = true;
        btn.textContent = btn.getAttribute('data-texto-agotado') || 'Agotado';
      }
    });
    if (botonDos) botonDos.disabled = !variante.disponible;
  }

  root.querySelectorAll('[data-vg-grupo]').forEach(function (grupo) {
    grupo.querySelectorAll('[data-vg-opcion]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        seleccionar(btn.getAttribute('data-vg-opcion'), grupo);
      });
    });
  });
  actualizar();
}

function vgInitCompra() {
  var form = document.getElementById('vg-form-producto');
  if (!form) return;
  var cart = document.querySelector('cart-drawer');

  if (cart && window.fetch && window.FormData) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var fd = new FormData(form);
      if (e.submitter && e.submitter.name) fd.set(e.submitter.name, e.submitter.value);
      if (!fd.get('quantity')) fd.set('quantity', 1);
      fd.delete('add');
      fd.append('sections', cart.getSectionsToRender().map(function (x) { return x.id; }).join(','));
      fd.append('sections_url', window.location.pathname);
      cart.setActiveElement(document.activeElement);
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
        body: fd
      }).then(function (r) { return r.json(); }).then(function (resp) {
        if (resp.status) { form.submit(); return; }
        if (window.publish && window.PUB_SUB_EVENTS) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'vg-producto', productVariantId: fd.get('id'), cartData: resp });
        }
        cart.classList.remove('is-empty');
        cart.renderContents(resp);
      }).catch(function () { form.submit(); });
    });
  }

  var sticky = document.querySelector('[data-vg-sticky]');
  var principal = form.querySelector('[data-vg-comprar]');
  if (sticky && principal) {
    var pendiente = false;
    var actualizarSticky = function () {
      pendiente = false;
      sticky.classList.toggle('vg-sticky--visible', principal.getBoundingClientRect().bottom < 0);
    };
    var pedirActualizacion = function () {
      if (pendiente) return;
      pendiente = true;
      window.requestAnimationFrame(actualizarSticky);
    };
    window.addEventListener('scroll', pedirActualizacion, { passive: true });
    window.addEventListener('resize', pedirActualizacion);
    actualizarSticky();
  }
}

if (!window.__vgScriptsIniciado) {
  window.__vgScriptsIniciado = true;
  document.addEventListener('DOMContentLoaded', function () {
    vgInitReveal();
    vgInitFaq();
    vgInitGaleriaProducto();
    vgInitVariantes();
    vgInitCompra();
  });
}
